//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	data() {
		return {
			telephone: '',
			singername: ''
		}
	},
	methods: {
		
	}
}



// WEBPACK FOOTER //
// ./src/components/xshoucang.vue